<template>
  <div class="position-relative">
    <div class="labor-burden-btn-wrapper mb-3">
      <set-labor-burden
        :disabled="!canEdit || disabled"
        @on-save="onUpdate"
      />
    </div>
    <ib-charts-placeholder v-if="isStaffAndPayrollEmpty" />
    <el-tabs
      v-else
      v-model="activeTab"
      class="mb-3 tabs"
    >
      <!-- Timeline -->
      <el-tab-pane
        :label="$t('timeline')"
        name="first"
        lazy
      >
        <div class="bg-white">
          <payroll-expenses-over-time
            v-if="activeTab === 'first'"
            class="pt-4 pb-1"
            chart-animations
          />
        </div>
      </el-tab-pane>
      <!-- /Timeline -->

      <!-- Breakdown -->
      <el-tab-pane
        :label="$t('breakdown')"
        name="second"
        lazy
      >
        <div class="bg-white">
          <distribution-of-payroll-expenses
            v-if="activeTab === 'second'"
            class="pt-4 pb-1"
            chart-animations
          />
        </div>
      </el-tab-pane>
      <!-- /Breakdown -->

      <!-- Table -->
      <el-tab-pane
        :label="$t('table')"
        name="third"
        lazy
      >
        <div class="bg-white pt-4 pb-2">
          <staff-and-payroll-table />
        </div>
      </el-tab-pane>
      <!-- /Table -->
    </el-tabs>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import DistributionOfPayrollExpenses from '@/views/Home/StoryMode/FinancialPlan/Components/Expenses/PayrollExpense/DistributionOfPayrollExpenses.vue'
import EventBus from '@/event-bus'
import MixinApiCalculations from '@/mixins/apiCalculations'
import MixinIdeaRoles from '@/mixins/permissions/ideaRoles'
import PayrollExpensesOverTime from '@/views/Home/StoryMode/FinancialPlan/Components/Expenses/PayrollExpense/PayrollExpensesOverTime.vue'
import SetLaborBurden from '@/views/Home/StoryMode/SetUp/StaffAndPayroll/SetLaborBurden.vue'
import StaffAndPayrollTable from '@/views/Home/StoryMode/SetUp/StaffAndPayroll/Tables/StaffAndPayrollTable.vue'

export default {
  name: 'PayrollExpensesTabs',

  components: { SetLaborBurden, StaffAndPayrollTable, PayrollExpensesOverTime, DistributionOfPayrollExpenses },

  mixins: [MixinApiCalculations, MixinIdeaRoles],

  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      activeTab: 'first'
    }
  },

  computed: {
    ...mapState(['idea']),

    isStaffAndPayrollEmpty () {
      return this.idea.storyMode.setUp.staffAndPayrolls.staffAndPayrolls.length === 0
    }
  },

  methods: {
    onUpdate () {
      this.loading = true
      EventBus.$emit('loading', true)
      Promise.all([
        this.getStaffAndPayroll(),
        this.getTotalCosts(),
        this.getProfitAndCashFlow()
      ])
        .then(() => {
          EventBus.$emit('loading', false)
        })
        .finally(() => {
          EventBus.$emit('loading', false)
        })
    }
  }
}
</script>

<style scoped lang="scss">
.labor-burden-btn-wrapper {
  display: flex;
  justify-content: flex-end;

  @include media-breakpoint-up($md) {
    position: absolute;
    top: -20px;
    right: 0;
    margin-bottom: unset;
  }
}

.tabs {
  ::v-deep {
    .el-tabs__content {
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: 0 0 8px 8px;
    }
  }
}
</style>
